// extracted by mini-css-extract-plugin
export default {"verticalStepper":"vertical-stepper__verticalStepper","stepItemTitle":"vertical-stepper__stepItemTitle","stepItemDescription":"vertical-stepper__stepItemDescription"};